import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';
import twitterText from 'twitter-text'
import { useEffect } from 'react';
import { useRef } from 'react';

const styles={
  formControl: {
    marginBottom: '100px'
  },
  image : {
    width: '100%',
    height: 'auto',
    maxWidth: '400px',
    marginBottom: '20px',
  },
  textField: {
    marginBottom: '20px',
  },
  disalogActions: {
    minWidth: "300px",
  },
  circularProgress: {
    textAlign: 'center',
  },
}

const TweetDialog = withMobileDialog()(withStyles(styles)((props) => {
  const {
    fullScreen,
    classes,
    bid,
    open,
    now,
    text,
    checkedSchedule,
    checkedImage,
    remainingLength,
    boardImage,
    url,
    shortURL,
    validTweet,
    isFetching,
    isCompleted,
    handleClose,
    handleEnter,
    handleEntering,
    handleExited,
    handleTextChange,
    handleCheckboxChange,
    handleTweet,
    buttonLabel,
  } = props;

  const prevUrl = useRef(url)

  useEffect(() => {
    if (url !== prevUrl.current) {
      handleEntering(url, twitterText)
    }
    prevUrl.current = url
  }, [url])

  return (
    <div>
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      onEnter={handleEnter}
      onExited={handleExited}
      aria-labelledby="responsive-dialog-title"
      >
      <DialogTitle><Word wid={WID.TWEET_DIALOG.DIALOG_TITLE}/></DialogTitle>
      {(shortURL === '' || boardImage === '') && (
        <DialogContent>
          <div className={classes.circularProgress}>
            <CircularProgress className={classes.progress} />
          </div>
        </DialogContent>
      )}
      {!(shortURL === '' || boardImage === '') && (
        <React.Fragment>
        <DialogContent>
          <FormGroup>
            <FormControl fullWidth>
              <TextField
                id={'tweet-text-field-' + bid}
                label={<Word wid={WID.TWEET_DIALOG.TEXT_LABEL}/>}
                helperText={remainingLength}
                multiline
                error={!validTweet}
                rows="5"
                className={classes.textField}
                onChange={handleTextChange('text', twitterText)}
                margin="normal"
                value={text}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={shortURL === '' || isFetching || isCompleted}
              />
            </FormControl>
            <Collapse in={checkedSchedule}>
              <FormControl>
                <TextField
                  id={"tweet-datetime-" + bid}
                  label={<Word wid={WID.TWEET_DIALOG.DATE_AND_TIME_LABEL}/>}
                  type="datetime-local"
                  defaultValue={now}
                  className={classes.textField}
                  onChange={handleTextChange('datetime')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={isFetching || isCompleted}
                />
              </FormControl>
            </Collapse>
          </FormGroup >
          <Collapse in={checkedImage === true && boardImage !== ''}>
            <img src={boardImage} className={classes.image} alt='download'/>
          </Collapse>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedSchedule}
                onChange={handleCheckboxChange('checkedSchedule')}
                value="schedule"
                color="primary"
                disabled={isFetching || isCompleted}
              />
            }
            label={<Word wid={WID.TWEET_DIALOG.SPECIFIED_DATE_AND_TIME_LABEL}/>}
            />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedImage}
                onChange={handleCheckboxChange('checkedImage')}
                value="image"
                color="primary"
                disabled={isFetching || isCompleted}
              />
            }
            label={<Word wid={WID.TWEET_DIALOG.ATTACHMENT_BOARD}/>}
          />
        </DialogActions>
        <DialogActions>
          {isFetching || isCompleted ? (
            <CircularProgress size={24}/>
          ) : (
            <Button
              onClick={handleTweet}
              disabled={Boolean(boardImage === '' || shortURL === '' || validTweet === false)}
              variant="contained"
              color="primary" 
            >
              {buttonLabel}
            </Button>
          )}
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
        </React.Fragment>
      )}
    </Dialog>
    </div>
  )
}))

export default TweetDialog


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/TweetDialog.js